<template>
    <el-form label-position="top">
        <el-form-item label="Title (the black & white claim on top)">
            <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="Please enter the title claim"
                    v-model="data.title">
            </el-input>
        </el-form-item>
        <el-form-item label="A/B titles">
            <el-input
                    type="text"
                    v-model="data.ab_titles[0]">
            </el-input>
            <el-input
                    type="text"
                    v-model="data.ab_titles[1]">
            </el-input>
            <el-input
                    type="text"
                    v-model="data.ab_titles[2]">
            </el-input>
        </el-form-item>

        <el-form-item label="Intelliapp Link">
            <el-input
                    type="text"
                    v-model="data.intelliapp_link">
            </el-input>
        </el-form-item>
    </el-form>
</template>

<style lang="less">
</style>
<script>
    export default {
        props: [
            'data'
        ],
        data () {
            return {
            }
        }
    }
</script>
